import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import "dayjs/locale/fr";

import { Container, Row } from "reactstrap";

import "chartist/dist/scss/chartist.scss";

//i18n
import { withTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PlayersList from "./components/PlayersList";
import { getProfile } from "store/slices/clubSlice";
import Header from "./components/Header";
import Agent from "./components/Agent";
import { fetchProfileStatus } from "store/slices/profileStatusSlice";
import ModalInfo from "components/CommonForBoth/ModalInfo";

const Dashboard = (props) => {
  const dispatch = useDispatch();
  document.title = "Dashboard | Playmaker - Club & Agent";
  const { isProfileComplete } = useSelector((state) => state.ProfileStatus)
  const role = localStorage.getItem("role");
  dayjs.locale("fr");

  useEffect(() => {
    if (role === "club" || role === "agent") {
      dispatch(getProfile());
      dispatch(fetchProfileStatus())
    }
  }, []);

  return (

    <div className="page-content">
      {/* {!isProfileComplete && (
        <ModalInfo
          trigger={true}
          title="Profil incomplet"
          message="Veuillez compléter votre profil pour améliorer votre visibilité et permettre aux autres de mieux vous découvrir."
          showCancel={false}
        />
      )
      } */}
      {isProfileComplete === false && (
        <ModalInfo
          trigger={true}
          title="Profil incomplet"
          message="Votre profil est actuellement incomplet. Veuillez le compléter pour améliorer votre visibilité et permettre aux autres de mieux vous découvrir."
          showCancel={false}
        />
      )}

      <Container fluid style={{ maxWidth: "100%" }}>
        <div className="page-title-box">
          <Row>
            {role === "club" ? (
              <>
                <Header />
                <PlayersList />
              </>
            ) : (
              <Agent />
            )}
          </Row>
        </div>
      </Container>
    </div>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(Dashboard);
